module.exports = __webpack_public_path__ + "static/img/kaede.c16f3d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kaede.png
// module id = nRuc
// module chunks = 11